module.exports = __webpack_public_path__ + "static/media/translations.1029.c0f951ce.resx";